/**

    Toggles the display of two elements in a given container. The two elements must have the same id, but different handles.
    The handle parameter is used to find the element to display, and the container's handle attribute is used to find the element to hide.
    The handle attribute is then updated to the new handle parameter.

    @param {String} handle - The new product handle.
    @param {HTMLElement} container - The container element holding the two elements to toggle.
    @param {string} id - The identifier used to find the two elements to toggle.
    @returns {void}
*/

export const toggleDisplay = (newHandle, container, id) => {
  if (!newHandle || !container || !id) {
    console.warn("Missing arguments for toggleDisplay");
  }

  const oldElem = container.querySelector(
    `#${id}__${container.dataset.handle}`
  );
  const newElem = container.querySelector(`#${id}__${newHandle}`);

  if (!oldElem || !newElem) {
    console.warn(`No elements found for ${id}__${newHandle}`);
    return;
  }

  container.dataset.handle = newHandle;

  oldElem.style.display = "none";
  newElem.style.display = "block";
};
